import React from 'react'

export default function BlogArticle() {
  return (
    <div className="container">
      <section className="card">
        <h1 className="h2">How to prepare for tax season</h1>
        <div className="kv">Nov 1, 2025 • 5 min read</div>
        <p className="kv" style={{marginTop:12}}>This article outlines key steps to prepare your records and communicate with your bookkeeper before tax filings. (Sample article content — replace with actual content.)</p>
      </section>
    </div>
  )
}
